import { Injectable } from '@angular/core'
import { NativeDateAdapter } from '@angular/material/core'

/**
 * DateAdapter que interpreta strings ISO date-only ("yyyy-MM-dd") como data LOCAL,
 * não UTC. Resolve o off-by-one do NativeDateAdapter em timezones negativos (ex: BR -3h).
 *
 * Sem este override, new Date("2025-08-25") = meia-noite UTC = 24/08 21h no BR.
 * Com este override, "2025-08-25" → new Date(2025, 7, 25) = meia-noite local = 25/08 ✓
 */
@Injectable()
export class LocalDateAdapter extends NativeDateAdapter {
  override deserialize(value: any): Date | null {
    if (typeof value === 'string') {
      const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
      if (match) {
        return new Date(+match[1], +match[2] - 1, +match[3])
      }
    }
    return super.deserialize(value)
  }
}
